<template>
    <div>
        <template v-if="serviceAggregate.enabledMeetingLocations.length > 1">
            <div>
                <FormControl
                    required
                    :label="
                        localizer.translate(TextTokenEnum.BookingForm_Location)
                    "
                >
                    <div class="space-y-2">
                        <template
                            v-for="enabledMeetingLocation in serviceAggregate.enabledMeetingLocations"
                            :key="enabledMeetingLocation.id"
                        >
                            <RadioInput
                                :useBookingFormThemeCssVariables="true"
                                :name="
                                    RequestBodyKeyEnum.ScheduleMeeting_MeetingLocationId
                                "
                                :label="
                                    !!enabledMeetingLocation.localizationTextToken
                                        ? localizer.translate(
                                              enabledMeetingLocation.localizationTextToken,
                                          )
                                        : enabledMeetingLocation.label
                                "
                                :value="enabledMeetingLocation.id"
                                :checked="
                                    enabledMeetingLocation.id ===
                                    selectedMeetingLocation?.id
                                "
                                @update:modelValue="
                                    handleLocationTypeChanged($event)
                                "
                                required
                            />
                        </template>
                    </div>
                </FormControl>
            </div>
        </template>
        <template v-else>
            <input
                class="optional"
                type="text"
                :name="RequestBodyKeyEnum.ScheduleMeeting_MeetingLocationId"
                :value="selectedMeetingLocation?.id"
            />
        </template>

        <template
            v-if="
                selectedMeetingLocation?.type === MeetingLocationTypeEnum.Phone
            "
        >
            <div>
                <PhoneNumberInput
                    :phoneNumberFieldName="
                        RequestBodyKeyEnum.ScheduleMeeting_PhoneNumber
                    "
                    :phoneCountryCodeFieldName="
                        RequestBodyKeyEnum.ScheduleMeeting_PhoneCountryCode
                    "
                    :localizer="localizer"
                    :selectedPhoneNumber="draftMeeting.phoneNumber"
                    :selectedPhoneCountryCode="
                        props.draftMeeting.phoneCountryCode
                    "
                    :required="true"
                />
            </div>
        </template>
        <template
            v-else-if="
                selectedMeetingLocation?.type ===
                MeetingLocationTypeEnum.InPersonAttendeeDefined
            "
        >
            <div>
                <FormControl
                    required
                    :label="
                        localizer.translate(TextTokenEnum.BookingForm_Address)
                    "
                >
                    <TextInput
                        :name="
                            RequestBodyKeyEnum.ScheduleMeeting_InPersonAttendeeDefinedMeetingLocationAddress
                        "
                        :useBookingFormThemeCssVariables="true"
                        :value="
                            draftMeeting.inPersonAttendeeDefinedMeetingLocationAddress
                        "
                        required
                    />
                </FormControl>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'
    import DraftMeeting from '@/App/Booking/Draft/Entity/DraftMeeting'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import RadioInput from '@/Shared/Component/Forms/RadioInput.vue'
    import {
        MeetingLocationTypeEnum,
        type MeetingLocationType,
    } from '@/Shared/AutoGenerated/Main'
    import PhoneNumberInput from '@/BookingForm/BookingForm/Component/PhoneNumberInput.vue'
    import type LocalizerService from '@/Shared/Service/Localization/LocalizerService'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import { TextTokenEnum } from '@/Shared/AutoGenerated/LocalizationEnum'

    const props = defineProps({
        draftMeeting: {
            type: Object as PropType<DraftMeeting>,
            required: true,
        },
        serviceAggregate: {
            type: Object as PropType<ServiceAggregate>,
            required: true,
        },
        localizer: {
            type: Object as PropType<LocalizerService>,
            required: true,
        },
    })

    // ---------------
    // Selected location type
    // ---------------

    const preSelectedMeetingLocation =
        props.serviceAggregate.getPreSelectedMeetingLocation()
    const draftMeetingMeetingLocation =
        props.serviceAggregate.getMeetingLocationByIdOrNull(
            props.draftMeeting.selectedMeetingLocationId,
        )
    const selectedMeetingLocation = ref<MeetingLocationType | null>(
        draftMeetingMeetingLocation ?? preSelectedMeetingLocation,
    )

    const handleLocationTypeChanged = (meetingLocationId: any) => {
        selectedMeetingLocation.value =
            props.serviceAggregate.getMeetingLocationById(meetingLocationId)
    }
</script>
